/**
 * Grilles compactes du détail U3130 (Absences et banques, Dépenses, Équipement) —
 * mêmes valeurs que `u3129TimesheetGridCompactStyles` (BL-0672) pour un rendu identique à U3129.
 */

import { U3130_HONORARIUM_COL_WIDTH_HOUR, U3130_HONORARIUM_HOUR_COL_CLASS } from "./u3130HonorariumGridCompactStyles";

export { U3130_HONORARIUM_COL_WIDTH_HOUR, U3130_HONORARIUM_HOUR_COL_CLASS };

/** Padding vertical minimal entre les lignes du tbody. */
export const U3130_GRID_COMPACT_ROW_CELL_PY = "py-0.5";

/** Pied de tableau : +5 px d’air entre les lignes de totaux (`2.5px` haut + bas par cellule). */
export const U3130_GRID_COMPACT_FOOTER_ROW_PY = "py-[2.5px]";

export const U3130_GRID_COMPACT_ROW_CHECKBOX_TD_CLASS = `w-10 px-1 ${U3130_GRID_COMPACT_ROW_CELL_PY} align-middle [&>div.flex]:box-border [&>div.flex]:min-h-8 [&>div.flex]:w-full [&>div.flex]:items-center [&>div.flex]:justify-center [&>div.flex]:gap-0 [&>div.flex>label:last-child:empty]:hidden`;

export const U3130_GRID_COMPACT_HOUR_COLUMN_CELL_X = "px-1";

export const U3130_GRID_COMPACT_ROW_HOUR_TD_BASE = `${U3130_GRID_COMPACT_HOUR_COLUMN_CELL_X} ${U3130_GRID_COMPACT_ROW_CELL_PY}`;

const U3130_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_BASE = `pl-1 ${U3130_GRID_COMPACT_FOOTER_ROW_PY} align-top text-right text-sm tabular-nums leading-none`;

/** Lecture / lignes readonly : −4 px pour aligner sur les boîtes compactes. */
export const U3130_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_CLASS_READ = `${U3130_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_BASE} pr-[calc(0.25rem+0.75rem+1px-4px)]`;

/** Édition (inputs actifs) : inset sans le décalage −4 px. */
export const U3130_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_CLASS_EDIT = `${U3130_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_BASE} pr-[calc(0.25rem+0.75rem+1px+2px)]`;

export const U3130_GRID_COMPACT_FOOTER_GUTTER_TD_CLASS = `w-10 pl-2 pr-1 ${U3130_GRID_COMPACT_FOOTER_ROW_PY}`;

export const U3130_GRID_COMPACT_FOOTER_LABEL_TD_BASE = `pl-3 pr-3 ${U3130_GRID_COMPACT_FOOTER_ROW_PY} text-left leading-none`;

/** Hauteur / bordure inputs en grille compacte (sans alignement texte). */
export const U3130_GRID_COMPACT_TABLE_CONTROL_CLASS =
  "[&_input:not([data-u2000-skip-grid-compact])]:box-border [&_input:not([data-u2000-skip-grid-compact])]:block [&_input:not([data-u2000-skip-grid-compact])]:h-8 [&_input:not([data-u2000-skip-grid-compact])]:min-h-8 [&_input:not([data-u2000-skip-grid-compact])]:max-h-8 [&_input:not([data-u2000-skip-grid-compact])]:w-full [&_input:not([data-u2000-skip-grid-compact])]:min-w-0 [&_input:not([data-u2000-skip-grid-compact])]:rounded-lg [&_input:not([data-u2000-skip-grid-compact])]:border [&_input:not([data-u2000-skip-grid-compact])]:border-gray-300 [&_input:not([data-u2000-skip-grid-compact])]:bg-surface [&_input:not([data-u2000-skip-grid-compact])]:!px-4 [&_input:not([data-u2000-skip-grid-compact])]:!py-0.5 [&_input:not([data-u2000-skip-grid-compact])]:text-sm [&_input:not([data-u2000-skip-grid-compact])]:leading-tight [&_button:not([data-u2000-skip-grid-compact])]:h-8 [&_button:not([data-u2000-skip-grid-compact])]:min-h-8 [&_button:not([data-u2000-skip-grid-compact])]:!py-0.5";

/** Colonnes heures uniquement (U2000InputDecimal). */
export const U3130_GRID_COMPACT_DECIMAL_CONTROL_CLASS = "[&_input]:text-right [&_input]:tabular-nums";

/** Onglet Absences et banques (BL-0689) — aligné U3129. */
export const U3130_ABSENCES_BANK_COL_WIDTH_TYPE_MIN = "17rem";
export const U3130_ABSENCES_BANK_TYPE_COL_CLASS = "min-w-[17rem] box-border text-left";

export const U3130_ABSENCES_BANK_TYPE_TD_CLASS = `px-2 ${U3130_GRID_COMPACT_ROW_CELL_PY} align-top text-left ${U3130_ABSENCES_BANK_TYPE_COL_CLASS}`;

export const U3130_ABSENCES_BANK_TYPE_HEADER_TH_CLASS = `px-2 py-2.5 text-left font-medium text-gray-700 ${U3130_ABSENCES_BANK_TYPE_COL_CLASS}`;

export const U3130_ABSENCES_BANK_FOOTER_TYPE_TD_CLASS = `pl-2 pr-2 ${U3130_GRID_COMPACT_FOOTER_ROW_PY} text-left leading-none`;

export const U3130_ABSENCES_BANK_TYPE_LABEL_INNER_CLASS =
  "min-w-0 w-full text-left text-sm leading-snug text-gray-800 break-words";
export const U3130_ABSENCES_BANK_FOOTER_LABEL_COL_CLASS = "min-w-0 max-w-full";

export const U3130_ABSENCES_BANK_COL_WIDTH_HOUR = "5rem";

export const U3130_ABSENCES_BANK_HOUR_COL_CLASS = "min-w-[5rem] w-[5rem] max-w-[5rem] shrink-0 box-border";

export const U3130_ABSENCES_BANK_DAY_HOUR_TH_CLASS = `pl-1 pr-[calc(0.25rem+0.375rem+1px)] py-2.5 text-right text-sm tabular-nums leading-none ${U3130_ABSENCES_BANK_HOUR_COL_CLASS}`;

export const U3130_ABSENCES_BANK_HOUR_BODY_TD_CLASS = `${U3130_GRID_COMPACT_ROW_HOUR_TD_BASE} ${U3130_ABSENCES_BANK_HOUR_COL_CLASS} align-top text-right`;

const U3130_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_BASE = `pl-1 ${U3130_GRID_COMPACT_FOOTER_ROW_PY} align-top text-right text-sm tabular-nums leading-none ${U3130_ABSENCES_BANK_HOUR_COL_CLASS}`;

export const U3130_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_CLASS_READ = `${U3130_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_BASE} pr-[calc(0.25rem+0.375rem+1px+1px)]`;

export const U3130_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_CLASS_EDIT = `${U3130_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_BASE} pr-[calc(0.25rem+0.375rem+1px+7px)]`;

export function u3130AbsencesBanquesTableMinWidth(options: { dayColumnCount: number }): string {
  const hourCols = options.dayColumnCount + 1;
  return `calc(${U3130_ABSENCES_BANK_COL_WIDTH_TYPE_MIN} + ${hourCols} * ${U3130_ABSENCES_BANK_COL_WIDTH_HOUR})`;
}
